import Color from 'color';

export const ColorPrimary = Color({ r: 207, g: 22, b: 25 });
export const ColorPrimaryHover = ColorPrimary.lighten(0.5);

export const ColorSecondary = Color({ r: 38, g: 74, b: 143 });
